import React, { useState, useEffect } from 'react';
import format from 'string-format';
import PopUp from './PopUp';
import Button from './Button';
import { withMessage } from './Message';
import ErrorMessage from './ErrorMessage';
import resx from '../../utilities/resx';
import { RESX_GLOBAL } from '../../Constants';

const SendMessage = ({ closeForm, userFullName, handleConnectionRequest, isSubmitting }) => {
    const [message, setMessage] = useState('');
    const [validationMessages, setValidationMessages] = useState({
        message: ''
    });

    const validate = () => {
        let validated = true;

        if (message.length > 400) {
            const newState = {
                message: 'Maximum 400 characters'
            };
            setValidationMessages(prevState => ({ ...prevState, ...newState }));
            validated = false;
        } else {
            const newState = {
                message: ''
            };
            setValidationMessages(prevState => ({ ...prevState, ...newState }));
        }

        return validated;
    };

    const handleFormSubmit = () => {
        if (message) {
            if (validate()) {
                handleConnectionRequest(message);
            }       
        } else {
            handleConnectionRequest(null);
        }
    };

    // for live validation
    useEffect(
        () => {
            if (message) {
                validate();
            }
        },
        [message]
    );

    return (
        <React.Fragment>
            <PopUp onClose={closeForm} popUpWidth="450px" popUpHeight="0">
                <div className="re-sendmessage-popup">
                    <div className="re-text-lg re-text-semibold">
                        {resx(RESX_GLOBAL, 'SEND_MESSAGE_POPUP_ADD_A_NOTE')}
                    </div>
                    <hr />
                    <div className="re-sendmessage-popup-conatiner">
                        <p
                            className="re-sendmessage-popup-desc"
                            dangerouslySetInnerHTML={{
                                __html: format(resx(RESX_GLOBAL, 'SEND_MESSAGE_POPUP_DESC_1'), userFullName)
                            }}
                        />
                        <form
                            className="formV2 formV2-fieldset re-sendmessage-popup-conatiner"
                            onSubmit={e => {
                                e.preventDefault();
                            }}
                        >
                            <label htmlFor="message" />
                            <textarea
                                type="text"
                                name="message"
                                id="message"
                                value={message}
                                onChange={e => setMessage(e.target.value)}
                                placeholder={resx(RESX_GLOBAL, 'SEND_MESSAGE_POPUP_DESC_2')}
                                data-testid="message"
                            />
                            <ErrorMessage validationMessages={validationMessages} fieldName="message" />
                            <div className="re-sendmessage-popup-actions">
                                <Button
                                    className={`re-btn ${isSubmitting && 'submitting'}`}
                                    text={resx(RESX_GLOBAL, 'SEND_MESSAGE_SUBMIT_BTN')}
                                    onClick={handleFormSubmit}
                                    dataTestid="submitform"
                                />
                            </div>
                        </form>
                    </div>
                </div>
            </PopUp>
        </React.Fragment>
    );
};

export default withMessage(SendMessage);
